/**
 * Luxury Scroll Animations
 * Handles the fade-up reveal effect for elements with .reveal class
 */

document.addEventListener('DOMContentLoaded', () => {
  const revealElements = document.querySelectorAll('.reveal');
  
  const revealOnScroll = () => {
    revealElements.forEach(el => {
      const elementTop = el.getBoundingClientRect().top;
      const elementVisible = 150;
      
      if (elementTop < window.innerHeight - elementVisible) {
        el.classList.add('active');
      }
    });
  };
  
  // Initial check
  revealOnScroll();
  
  // Scroll event
  window.addEventListener('scroll', revealOnScroll);

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', () => {
    // Re-select elements as new ones might have been added
    const newRevealElements = document.querySelectorAll('.reveal');
    newRevealElements.forEach(el => {
      const elementTop = el.getBoundingClientRect().top;
      if (elementTop < window.innerHeight) {
        el.classList.add('active');
      }
    });
  });
});
